import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';
import UpdateIssue from './UpdateIssue';

function IssuesDash({ showMessage, page_title }) {

  useEffect(() => {
              document.title = page_title;
          }, [page_title]);

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("view");
  const [showUpdate, setShowUpdate] = useState(false);
  const [currentIssueId, setCurrentIssueId] = useState(null);

  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [dateRange, setDateRange] = useState("");
  const [image, setImage] = useState(null);
  const [pdf, setPdf] = useState(null);

  const fileImageRef = useRef(null);
  const filePdfRef = useRef(null);

  const [issues, setIssues] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const tabActivated = (tabName) => {
    navigate(`?tab=${tabName}`);
    setActiveTab(tabName);
    setShowUpdate(false);
  };

  const reloadForm = () => {
    setTitle("");
    setDate("");
    setDateRange("");
    setImage(null);
    setPdf(null);
    if (fileImageRef.current) fileImageRef.current.value = "";
    if (filePdfRef.current) filePdfRef.current.value = "";
  };

  const submitIssue = async () => {
    if (!title || !date || !dateRange || !image || !pdf) {
      showMessage("error", "All fields are required.");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("date", date);
    formData.append("date_range", dateRange);
    formData.append("image", image);
    formData.append("pdf", pdf);

    try {
      const response = await fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=submitIssue", {
        method: "POST",
        credentials: "include",
        body: formData,
      });
      const data = await response.json();
      if (data.success) {
        showMessage("success", "Issue submitted successfully.");
        reloadForm();
        tabActivated("view");
        setTimeout(() => window.location.reload(), 1000);
      } else {
        showMessage("error", data.error || "Submission failed.");
      }
    } catch (err) {
    console.error("Error parsing or fetching:", err);
    showMessage("error", "Server returned invalid response. Check console for details.");
    }
  };

  const deleteIssue = async (id) => {
    const confirmed = window.confirm("Are you sure you want to delete this issue?");
    if (!confirmed) return;

    try {
      const response = await fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=deleteIssue", {
        method: "POST",
        credentials: "include",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id }),
      });
      const data = await response.json();
      if (data.success) {
        showMessage("success", "Issue deleted successfully.");
        setTimeout(() => window.location.reload(), 1000);
      } else {
        showMessage("error", data.error);
      }
    } catch (err) {
      showMessage("error", err.message);
    }
  };

  const updateIssue = (id) => {
    setCurrentIssueId(id);
    setShowUpdate(true);
  };

  useEffect(() => {
    fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=checkUserSession", {
      method: "GET",
      credentials: "include",
    })
      .then(res => res.json())
      .then(data => {
        if (data.success !== 'true') navigate("/dashboard/login");
      })
      .catch(err => console.log(err));

    fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=getAllIssues")
      .then(res => res.json())
      .then(data => {
        if (data.success) setIssues(data.issues);
      })
      .catch(err => console.log(err));
  }, []);

  const dashLogout = () => {
    fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=removeUserSession", {
      method: "GET",
      credentials: "include",
    })
      .then(res => res.json())
      .then(data => {
        if (data.success === 'true') {
          showMessage("success", "Logged out successfully.");
          navigate("/dashboard/login");
        }
      })
      .catch(() => showMessage("error", "Something went wrong."));
  };

  const dashBack = () => navigate("/dashboard");

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = issues.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(issues.length / itemsPerPage);


  const formatDate = (dateString) => {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = date.toLocaleString('en-US', { month: 'short' });
            const year = date.getFullYear();
    
            return `${day}-${month}-${year}`;
};

const publishIssue = async (id) => {
  const formData = new FormData();
  formData.append("id", id);

  try {
    const response = await fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=togglePublishIssue", {
      method: "POST",
      credentials: "include",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      showMessage("success", `Issue ${data.newStatus === "1" ? "published" : "unpublished"} successfully.`);
      setTimeout(() => window.location.reload(), 1000);
    } else {
      showMessage("error", data.error || "Failed to update publish status.");
    }
  } catch (err) {
    showMessage("error", "An error occurred.");
    console.error(err);
  }
};

  return (
    <div className='dash_section'>
      <div className="dash_wrapper">

        <div className='dash_logout'>
          <div className='dash_back_cta' onClick={dashBack}>Dashboard</div>
          <div className='dash_logout_cta' onClick={dashLogout}>Logout</div>
        </div>

        <div className='dash_header_tabs'>
          <div className='dash_header_tab' onClick={() => tabActivated('view')} style={activeTab === "view" ? { borderBottom: '2px solid gray' } : {}}>View Issues</div>
          <div className='dash_header_tab' onClick={() => tabActivated('create')} style={activeTab === "create" ? { borderBottom: '2px solid gray' } : {}}>Add New Issue</div>
        </div>

        <div className='dash_body_tab' style={activeTab === "view" ? { display: 'block' } : { display: 'none' }}>
          {!showUpdate ? (
            <>
              <h2 className='dash_body_title'>Issues - View</h2>
              <div className='dash_table_wrapper'>
                <div className='dash_table_body'>
                  {currentItems.map((issue) => (
                    <div key={issue.id} className='dash_table_body_wrapper'>
                      <p><strong>ID:</strong> {issue.id}</p>
                      <div className='dash_table_info'>
                        <div className='issues_dash_image'>
                          <img src={issue.image} alt={issue.title} />
                        </div>
                        <div className='dash_table_info_content'>
                          <p className='dash_table_info_title'>{parse(issue.title)}</p>
                          <p className='dash_table_info_email'>{formatDate(issue.date)}</p>
                          <p className='dash_table_info_email'>Date Range: {issue.date_range}</p>
                          <div className='pdf_view_issue'>
                            <a href={issue.pdf} download target="_blank" rel="noreferrer" >View PDF</a>
                            <br/>
                            <button
                              className='publish_issue'
                              style={{
                                border: `1px solid ${issue.publish === 1 ? "orange" : "green"}`,
                                backgroundColor: issue.publish === 1 ? "orange" : "green",
                                color: "#fff",
                                padding: "6px 12px",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                              onClick={() => publishIssue(issue.id)}
                            >
                              {issue.publish === 1 ? "Unpublish" : "Publish"}
                          </button>

                          </div>
                          
                        </div>
                      </div>
                      <div className='dash_table_info_actions'>
                        <button className='dash_table_info_action' onClick={() => updateIssue(issue.id)}>Update</button>
                        <button className='dash_table_info_action info_action_delete' onClick={() => deleteIssue(issue.id)}>Delete</button>
                      </div>
                    </div>
                  ))}

                  {/* Pagination */}
                    <div style={{ marginTop: "1rem", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", gap: "1rem" }}>
                    {/* Left Arrow */}
                    <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{
                        height: "40px",
                        width: "40px",
                        backgroundColor: "#eee",
                        color: "#000",
                        border: "none",
                        borderRadius: "100px",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                        opacity: currentPage === 1 ? 0.5 : 1
                        }}
                    >
                        <span className="fa-solid fa-arrow-left"></span>
                    </button>

                    {/* Page Info */}
                    <span>
                        Page {currentPage} of {totalPages}
                    </span>

                    {/* Right Arrow */}
                    <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{
                        height: "40px",
                        width: "40px",
                        backgroundColor: "#eee",
                        color: "#000",
                        border: "none",
                        borderRadius: "100px",
                        cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                        opacity: currentPage === totalPages ? 0.5 : 1
                        }}
                    >
                        <span className="fa-solid fa-arrow-right"></span>
                    </button>
                    </div>

                </div>
              </div>
            </>
          ) : (
            <>
              <h2 className='dash_body_title'>Issues - Update</h2>
              <UpdateIssue id={currentIssueId} showMessage={showMessage} setShowUpdate={setShowUpdate} />
            </>
          )}
        </div>

        <div className='dash_body_tab' style={activeTab === "create" ? { display: 'block' } : { display: 'none' }}>
          <h2 className='dash_body_title'>Add New Issue</h2>
          <div className='dash_update_records'>
            <label>1. Title</label><br />
            <input className='dash_input' type="text" value={title} onChange={(e) => setTitle(e.target.value)} /><br />
            <label>2. Date</label><br />
            <input className='dash_input' type="date" value={date} onChange={(e) => setDate(e.target.value)} /><br />
            <label>3. Date Range</label><br />
            <input className='dash_input' type="text" value={dateRange} onChange={(e) => setDateRange(e.target.value)} /><br />
            <label>4. Upload Image</label><br />
            <input ref={fileImageRef} className='dash_file_upload' type="file" onChange={(e) => setImage(e.target.files[0])} /><br />
            <label>5. Upload PDF</label><br />
            <input ref={filePdfRef} className='dash_file_upload' type="file" onChange={(e) => setPdf(e.target.files[0])} /><br />

            <div className='dash_buttons_wrapper'>
              <button className='dash_form_buttom' onClick={submitIssue}>Submit</button>
              <button className='dash_form_buttom dash_reset' onClick={reloadForm}>Reset</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IssuesDash;